var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psIndicatorAmount"},[_c('div',{staticClass:"labelIndicator",style:(_vm.config.labelIndicator.color)},[_vm._v(_vm._s(_vm.config.labelIndicator.text))]),_c('div',{staticClass:"value",style:(_vm.config.amount)},[_vm._v(_vm._s(_vm._f("money")(_vm.value))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }